import React from 'react';
import { Route } from 'react-router-dom';

import { ADMIN_ORGANIZATIONS_APP_PATHS } from '../constants/organizations-paths.constants';
import AdminOrganizationsListView from '../views/admin/AdminOrganizations.view';
import AdminOrganizationDetailsView from '../views/admin/AdminOrganizationDetails.view';
import AdminCreateOrganizationOrderView from '../../orders/views/AdminCreateOrganizationOrder.view';

export default function AdminOrganizationsRoutes() {
  return (
    <React.Fragment>
      <Route exact path={ADMIN_ORGANIZATIONS_APP_PATHS.ORGANIZATIONS_LIST} component={AdminOrganizationsListView} />
      <Route
        exact
        path={ADMIN_ORGANIZATIONS_APP_PATHS.ORGANIZATION_CREATE_ORDER}
        component={AdminCreateOrganizationOrderView}
      />
      <Route exact path={ADMIN_ORGANIZATIONS_APP_PATHS.ORGANIZATION_DETAILS} component={AdminOrganizationDetailsView} />
    </React.Fragment>
  );
}
